import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator';
import moduleStore from '../store/migu';
import Vue from 'vue';
import PageState from '../store/state';
import to from 'await-to-js';
import { toPublishPage } from '../utils/util';
import { MiguConfig } from '../utils/constant';

/**components**/
@Component({
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class worksPage extends Vue implements IvuePage<PageState> {
  state = new PageState();
  self: Vue = this;

  // 筛选项数据
  showFilters = false;
  styles = [];
  type = '全部类型';
  date = '全部日期';
  dateValue = '全部日期';
  activeKey: any = 0;
  activeValue = '全部类型';
  minDate = new Date('2000-01-01')
  showTypesPopover: boolean = false;
  showDatePopover: boolean = false;
  show = false;

  // 列表数据
  loading: Boolean = false;
  finished: Boolean = true;
  pageIndex: any = 0;
  pageSize: any = 12;
  total_pages: any = 0;
  works = [];
  statusUpdateQueue = []; // 需要进行状态轮询的队列
  statusUpdateTimer = null;
  articleIdMigu = '';

  imgDarkDefault = 'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/baohuo-mp-cdn/cdnData/images/baohuo/default_1706873947201.png';
  iconDel = 'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/baohuo-mp-cdn/cdnData/images/baohuo/del_icon_1706873947201.png'
  iconEdit = 'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/baohuo-mp-cdn/cdnData/images/baohuo/edit_icon_1706873947201.png';
  iconDownload = 'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/baohuo-mp-cdn/cdnData/images/baohuo/download_icon_1706873947201.png'
  imgLightDefault = '/images/migu/newYear/default_cover.png';
  get isNewYear() {
    return localStorage.getItem('theme') === 'New_Year';
  }
  get imgDefault() { return this.isNewYear ? this.imgLightDefault : this.imgDarkDefault }

  @Watch('statusUpdateQueue', { deep: true })
  listenStatusUpdateQueue() {
    if (this.statusUpdateTimer) return;
    this.queryArticleStatusBatch();
  }

  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
    localStorage.removeItem('ww_token');
    localStorage.setItem('isMigu', 'true');
  }
  mounted() {
    this.upLoadData();
    // --todo 设置页面标题
    document.title = '创作记录';
    // 获取本地存储的 articleIdMigu
    this.articleIdMigu = localStorage.getItem('articleIdMigu')||'';
  }
  beforeDestroy() {
    clearTimeout(this.statusUpdateTimer);
  }

  //加载更多数据
  upLoadData() {
    if (this.pageIndex <= this.total_pages) {
      this.pageIndex = this.pageIndex + 1;
      this.getWorks();
    }
  }

  toCreate() {
    this.$router.push({ path: '/migu' });
  }
  toPlay(item) {
    const videoUrl = item.lastExportVideoUrl;
    const coverUrl = item.coverUrl;
    if (!videoUrl) return;
    this.$router.push({ path: '/video-play', query: { videoUrl, coverUrl, articleId: item.articleId } });
  }
  async toPublish(item) {
    const obj: any = {
      videoUrl: item.lastExportVideoUrl,
      coverUrl: item.coverUrl,
    };
    if ((window as any)._amberTrack) {
      const vuid = localStorage.getItem('vuid') || '';
      (window as any)._amberTrack('music_aigc_publish_ringtone', [
        {
          EK: 'triggerType',
          EV: '2'
        },
        {
          EK: 'scene',
          EV: MiguConfig.projectId
        },
        {
          EK: 'videoUrl',
          EV: item.lastExportVideoUrl || ''
        },
        {
          EK: 'resId',
          EV: item.articleId || ''
        },
        {
          EK: 'vuid',
          EV: vuid
        },
        {
          EK: 'appId',
          EV: MiguConfig.appid
        },
        {
          EK: 'channel',
          EV: MiguConfig.schannel
        }
      ], true, 'beacon');
      console.log('_amberTrack music_aigc_publish_ringtone', {
        EK: 'videoUrl',
        EV: item.lastExportVideoUrl || ''
      },
      {
        EK: 'resId',
        EV: item.articleId || ''
      },
      {
        EK: 'vuid',
        EV: vuid
      });
    }
    setTimeout(async () => {
      await toPublishPage(obj);
    }, 200);
  }

  // status
  // INIT(0, "初始化", "初始化"),
  // LINE_UP(1, "排队中", "排队中"),
  // TEXT_EXTRACT_FEATURES(2, "文案获取角色特性", ""),
  // TEXT_GENERATE_IMG_PROMPTS(3, "文案生成图片prompt", ""),
  // PROMPT_GENERATING(4, "生图中", "剪辑中"),
  // FAILED(5, "失败", "剪辑失败"),
  // SUCCESS(6, "成功", "成功");

  // lastExportTaskStatus
  // INIT(0, "初始化", false, 0, 0),
  // GENERATE(1, "合成中", false, 1, 30),
  // COMPOSE_SUCCESS(2, "视频合成成功", true, 100, 100),
  // COMPOSE_FAILED(3, "视频合成失败", true, 100, 100),
  // ERROR(4, "失败-暂未使用", true, 100, 100),
  // TRANSITION(5, "转场特效生成中", false, 60, 90),
  // ZOOM_PAN(6, "微动生成中", false, 30, 60),
  // VIDEO_SPEED(7, "视频变速中", false, 50, 90),
  getStatusValue({ status, lastExportTaskStatus }) {
    const statusMap = ['init', 'wait', 'procecing', 'procecing', 'procecing', 'fail', 'success'];
    if (statusMap[status] === 'success') {
      const exportStatusMap = ['init', 'procecing', 'success', 'fail', 'fail', 'procecing', 'procecing'];
      return exportStatusMap[lastExportTaskStatus || 1] || '';
    }
    return statusMap[status] || '';
  }
  getStatusValueName({statusValue, statusName}) {
    if (statusValue === 'success') return '生成成功';
    if (statusValue === 'fail') return '生成失败';
    return statusName;
  }
  getProgress({ status, progress, exportProgress }) {
    const data = status === 6 ? exportProgress : progress;
    let process = 0;
    if(data) process = parseInt(data.match(/\d+/g)) || 0;
    if(status === 6 && !process) return ' ';
    return process + '%';
  }
  formatWorkItem(item) {
    item.statusValue = this.getStatusValue(item);
    item.statusValueName = this.getStatusValueName(item);
    item.progressValue = this.getProgress(item);
    if (item.statusValue === 'fail' && item.progress && item.progress.includes('敏感词')) {
      // title字符都替换为*
      item.title = item.title.replace(/./g, '*');
    }
    if (item.statusValue === 'success' && this.articleIdMigu) { 
      this.sendMgaEvent(item);
    }
    return item;
  }

  async getWorks() {
    this.loading = true;
    this.finished = false;

    let startDate = this.date.split('+')[0]
    let endDate = this.date.split('+')[1]
    let params = {
      page: this.pageIndex,
      size: this.pageSize,
      startDate: (() => {
        const now = new Date();
        now.setDate(now.getDate() - 7);
        // 补零
        const m = (now.getMonth() + 1).toString().padStart(2, '0');
        const d = now.getDate().toString().padStart(2, '0');
        return `${now.getFullYear()}-${m}-${d}`;
      })(),
      endDate: '',
      styleCode: this.type === '全部类型' ? '' : this.type,
    }
    const [err, res] = await to(this.$http("getArticleList", params))
    this.loading = false;
    this.finished = true;
    if (err) {
      this.pageIndex = 0;
      return this.$toast(err.message);
    }
    if (res.code !== 200 || !res.data) {
      this.pageIndex = 0;
      return this.$toast(res.message);
    }

    this.total_pages = res.data.total_pages;
    const list = (res.data.results || []).map((item) => {
      return this.formatWorkItem(item);
    })
    this.finished = false;
    this.works = this.pageIndex === 1 ? list : [...this.works, ...list];
    if (this.pageIndex >= this.total_pages) {
      this.finished = true;
    }
    this.statusUpdateQueue = this.works.filter(item => ['init', 'procecing', 'wait'].includes(item.statusValue));
  }

  async queryArticleStatusBatch() {
    if (this.statusUpdateQueue.length === 0) return;
    const articleIds = this.statusUpdateQueue.map((item) => item.articleId).join(",");
    const [error, res] = await to(this.$http("getArticleStatusBatch", { articleIds }));
    const list = res && res.data || [];
    if (!error && res.code === 200 && list.length) {
      list.forEach((resItem) => {
        const item = this.works.find((v) => v.articleId === resItem.articleId);
        if (item) {
          delete resItem.rank;
          Object.assign(item, resItem);
          this.formatWorkItem(item);
          if (!['init', 'procecing', 'wait'].includes(item.statusValue)) {
            this.statusUpdateQueue = this.statusUpdateQueue.filter(
              (v) => v.articleId !== item.articleId
            );
          }
        }
      });
    }
    if (this.statusUpdateQueue.length > 0) {
      this.statusUpdateTimer = setTimeout(this.queryArticleStatusBatch, 5000);
    }
  }

  /************************************************ 筛选项 *****************************************/
  //选择一种类型
  choose(item, key) {
    if (item == 'allDate') {
      this.date = '全部日期';
      this.dateValue = '全部日期';
      return
    }
    this.activeKey = key;
  }
  //重置所有
  resetFilters() {
    this.type = '全部类型';
    this.date = '全部日期';
    this.dateValue = '全部日期';
    this.activeKey = 0;
    this.activeValue = this.styles[this.activeKey].name;
    this.reloadWorks()
  }
  reloadWorks() {
    this.pageIndex = 1;
    this.total_pages = 0;
    this.getWorks();
  }
  getStyles() {
    this.$http("getStyle", { pageSize: 50 }).then(res => {
      if (res.code == 200) {
        this.styles = res.data.results
        this.styles.unshift({ 'id': 0, 'name': "全部类型", nameEN: '' });
      }
    })
  }

  //重置
  reset() {
    this.activeKey = 0;
    this.activeValue = this.styles[this.activeKey].name;
    if (this.showTypesPopover) {
      this.type = '全部类型';
    } else {
      this.date = '全部日期';
      this.dateValue = '全部日期';
    }
    this.showTypesPopover = false;
    this.showDatePopover = false;
    this.reloadWorks();
  }
  //选择类型-完成
  finishType() {
    this.showTypesPopover = false;
    this.type = this.styles[this.activeKey].nameEN;
    this.activeValue = this.styles[this.activeKey].name;
    this.reloadWorks();
  }
  //选择日期完成
  finishDate() {
    this.showDatePopover = false;
    this.reloadWorks();
  }
  //格式化日期
  formatDate(date, type) {
    let year = date.getFullYear();
    let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    return type == 'dot' ? `${year}.${month}.${day}` : `${year}-${month}-${day}`;
  }
  //选中日期
  onConfirmDate(date) {
    this.show = false;
    this.showDatePopover = false;
    this.date = this.formatDate(date[0], '') + '+' + this.formatDate(date[1], '');
    this.dateValue = this.formatDate(date[0], 'dot') + '-' + this.formatDate(date[1], 'dot')
    this.reloadWorks();
  }
  sendMgaEvent(item) {
    if (item.articleId != this.articleIdMigu) {
      return;
    }
    if ((window as any)._amberTrack) {
      const vuid = localStorage.getItem('vuid') || '';
      const creationTaskId = localStorage.getItem('creationTaskIdMigu') || '';
      console.log('_amberTrack music_aigc_complete_task',
      {
        EK: 'taskId',
        EV: creationTaskId
      },
      {
        EK: 'videoUrl',
        EV: item.lastExportVideoUrl || ''
      },
      {
        EK: 'vuid',
        EV: vuid
      });
      (window as any)._amberTrack('music_aigc_complete_task', [
        {
          EK: 'triggerType',
          EV: '2'
        },
        {
          EK: 'scene',
          EV: MiguConfig.projectId
        },
        {
          EK: 'taskId',
          EV: creationTaskId
        },
        {
          EK: 'videoUrl',
          EV: item.lastExportVideoUrl || ''
        },
        {
          EK: 'vuid',
          EV: vuid
        },
        {
          EK: 'appId',
          EV: MiguConfig.appid
        },
        {
          EK: 'channel',
          EV: MiguConfig.schannel
        }
      ], true, 'beacon');
      localStorage.removeItem('creationTaskIdMigu');
    }
  }
}
